import React,{useState,useEffect,} from 'react'
import { Table,Space,Checkbox, Radio,DatePicker} from 'antd'
import Main from '../../cpn/Main';
import { useTuanHaoListQuery } from '../../store/BnsKeJiApi';
import GetFirm from '../../gf/firm/GetFirm';
import dayjs from 'dayjs';
const {RangePicker} = DatePicker
function YwzLedgerList() {
    const [query,setQuery] = useState({
        ebn_e_id:"",
    }); 
    const {data,isSuccess} = useTuanHaoListQuery(query,{refetchOnMountOrArgChange:1,skip:!query.ebn_e_id})
    const [list, setList] = useState();   
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                // console.log(data);                
                const newArr = data.Result.map(item => {
                    const {ebn_id:key,guige,ebn_client_id,ebn_yw_name,ebn_team_num,ebn_dept_id,photo_album_id,ebn_expenditure_num,ebn_income_num,ed_name,ebn_name,ebn_content,ebn_uname,ebn_ctime,ebn_update_ctime,ebn_update_uname,ec_name,ebn_image_file,ebn_date,eg_name,ebn_eg_id,ebn_audit2_ctime,ebn_audit4_uname,ebn_audit4_ctime,ebn_audit3_uname,ebn_audit3_ctime,ebn_audit2_uname,ebn_audit_ctime,ebn_audit_uname,ebn_state,} = item;
                    return item = {key,guige,ebn_client_id,ebn_yw_name,ebn_team_num,ebn_dept_id,photo_album_id,ebn_expenditure_num,ebn_income_num,ed_name,ebn_name,ebn_content,ebn_uname,ebn_ctime,ebn_update_ctime,ebn_update_uname,ec_name,ebn_image_file,ebn_date,eg_name,ebn_eg_id,ebn_audit4_ctime,ebn_audit4_uname,ebn_audit3_ctime,ebn_audit3_uname,ebn_audit2_ctime,ebn_audit2_uname,ebn_audit_ctime,ebn_audit_uname,ebn_state,}
                }) 
                
                setList(newArr)
                 
               
                }else{
                setList('')
            }            
        }
    }, [data, isSuccess])  

    const columns = [
        {
            key: 'ebn_state',
            title: '状态',
            dataIndex: 'ebn_state',
            width:'3%'  
        }, 
        {
            key: '1',
            title: '团队编号',
            dataIndex: 'ebn_team_num', 
            sorter: {
                compare: (a, b) => a.ebn_team_num - b.ebn_team_num,
            },
            width:'7%',           
            
        }, 
        {
            key: '2',
            title: '出发日期',
            dataIndex: 'ebn_date',
            width:'6%'  
        }, 
        {
            key: '3',
            title: '部门',
            dataIndex: 'ed_name', 
            width:'6%'            
        },  
        {
            key: '4',
            title: '销售员',
            dataIndex: 'ebn_yw_name',
            width:'6%'  
        },  
        {
            key: '5',
            title: '客户',
            dataIndex: 'ec_name',
            width:'6%'  
        },         
        {
            key: '6',
            title: '产品',
            dataIndex: 'eg_name',
            width:'10%',
            hidden:'true',  
            render:(text,record) => {
                let arr = []
                if(record.guige){
                    arr = record.guige.map((item) => {
                        return <span key={item.egg_id}>{item.egg_name}{item.guigeNum}</span>
                    })
                }
                return <>
                    <div>{text}</div>
                    <Space>{arr}</Space>
                </>
            }
        },           
        {
            key: '8',
            title: '收入',
            dataIndex: 'ebn_income_num',
            width:'4%'  
        }, 
        {
            key: '9',
            title: '支出',
            dataIndex: 'ebn_expenditure_num',
            width:'4%'  
        }, 
        {
            key: '10',
            title: '利润',
            render:(_,record) => {
                return <>{(+record.ebn_income_num + +record.ebn_expenditure_num).toFixed('2')}</>
            },
            width:'4%'  
        },     
        {
            key: '11',
            title: '操作员',
            render:(_,record) => {
                return<>{record.ebn_ctime + ' ' + record.ebn_uname.replace(/"/g,'')}</>
            },
            width:'8%'  
        },                                   
    ]
    //当前页码
    const [current, setCurrent] = useState(localStorage.getItem('ebn_query_page')?localStorage.getItem('ebn_query_page'):'1');
    //当前每页数量
    const [pageSize,setPageSize] = useState(localStorage.getItem('ebn_query_page_size')?localStorage.getItem('ebn_query_page_size'):"20")
    //列显示   
    const defaultCheckedList = columns.map((item) => item.key);
    const [checkedList, setCheckedList] = useState(localStorage.getItem('groupListColumn')?localStorage.getItem('groupListColumn').split(','):defaultCheckedList);
    const options = columns.map(({ key, title }) => ({
        label: title,
        value: key,
    }));
    const newColumns = columns.map((item) =>{
        if(localStorage.getItem('groupListColumn')){
            return {...item,hidden:!localStorage.getItem('groupListColumn').includes(item.key)}
        }else{
            return {...item,hidden: !checkedList.includes(item.key),}
        }
    });    

    //搜索样式
    const [searchStyle,setSearchStyle] = useState('1')
    return (
        <Main  t1='团队' >
            <Space>
                <GetFirm
                    label='企业'
                    wrapperCol={{span:15}}
                    required
                    getFirm={(e) => {
                        setQuery(prevState=>({...prevState,ebn_e_id:e}))
                    }}
                    style={{width:"200px"}}
                    formStyle={{marginBottom:'0'}}
                />
                <Radio.Group onChange={(e) => {
                    setQuery(prevState=>({...prevState,ebn_state:e.target.value}))
                }}>
                    <Radio value='0'>全部</Radio>
                    <Radio value='1'>已删除</Radio>
                    <Radio value='2'>未删除</Radio>
                    <Radio value='3'>已隐藏</Radio>
                </Radio.Group>
                <RangePicker
                    onChange={(e) => {
                        setQuery(prevState=>({
                            ...prevState,
                            s_date:dayjs(e[0]).format('YYYY-MM-DD'),
                            e_date:dayjs(e[1]).format('YYYY-MM-DD'),
                        }))
                    }}
                />
            </Space>
            <Table 
                style={{marginTop:"20px"}}
                columns={newColumns} 
                dataSource={list} 
                pagination={{
                    showSizeChanger:true,
                    showTotal:(total) => `共${total}条`,
                    current:current,
                    onChange:(e,f) => {
                        setCurrent(e)
                        setPageSize(f)
                        localStorage.setItem('ebn_query_page',e);
                        localStorage.setItem('ebn_query_page_size',f);
                    },
                    pageSize:pageSize,
                    showTitle:true
                }}/>
            <div style={{textAlign:'right',width:"100%"}}>
                <Space>
                    <div>
                        <span>查询样式：</span>
                        <Radio.Group
                            value={searchStyle} 
                            onChange={(e) => {
                                setSearchStyle(e.target.value)
                                localStorage.setItem('LedgerListSearch',e.target.value)
                            }}>
                            <Radio value='1'>平铺式</Radio>
                            <Radio value='2'>弹出式</Radio>
                        </Radio.Group>
                    </div>
                    <div>
                        <span>列显示：</span>
                        <Checkbox.Group 
                            value={localStorage.getItem('groupListColumn')?localStorage.getItem('groupListColumn').split(','):defaultCheckedList}
                            options={options}
                            onChange={(value) => {
                                localStorage.setItem('groupListColumn',value+'')
                                setCheckedList(value);
                            }}>产品 
                        </Checkbox.Group>  
                    </div>   
                </Space>           
            </div>
        </Main>
    )
}

export default YwzLedgerList